import React from "react";
import Carousel from "react-material-ui-carousel";
import "./Board.css";

export function Board(props) {
  let images = [
    "https://cdn.wallpapersafari.com/52/84/IBemTn.jpg",
    "https://weneedfun.com/wp-content/uploads/2016/09/Helen-Keller-Quotes-7.jpg",
    "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/short-inspirational-quotes-mario-fernandez-1597428954.jpg?crop=1xw:1xh;center,top&resize=480:*",
    "https://www.birthdaywishes.expert/wp-content/uploads/2015/05/inspirational-quote-dr-seuss-3.jpg",
  ];

  return (
    <div className="boardBackground">
      <Carousel className="container">
        {images.map((src, i) => (
          <img className="imgC" src={src} />
        ))}
      </Carousel>
    </div>
  );
}
